// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__SXTn0","logo":"Header_logo__shVBB","logOutLink":"Header_logOutLink__MzNiP","pageLinks":"Header_pageLinks__+bZY9"};